import _implicitStylesheets from "./listingCard.css";
import _implicitScopedStylesheets from "./listingCard.scoped.css?scoped=true";
import _axImage from "ax/image";
import _wdsStarRatings from "wds/starRatings";
import _axBadge from "ax/badge";
import _wdsTag from "wds/tag";
import _axCard from "ax/card";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a${"a0:href"} type-style="display-7" util-style="ellipsis" class="card-target${0}"${2}>${"t1"}</a>`;
const $fragment2 = parseFragment`<p type-style="body-3" util-style="ellipsis"${3}>${"t1"}</p>`;
const $fragment3 = parseFragment`<p type-style="body-3" class="description${0}" util-style="multi-line-ellipsis"${2}>${"t1"}</p>`;
const stc0 = {
  "type": "listingTile"
};
const stc1 = {
  attrs: {
    "grid": ""
  },
  key: 2
};
const stc2 = {
  classMap: {
    "title-creds": true
  },
  attrs: {
    "grid": "",
    "axis": "column"
  },
  key: 4
};
const stc3 = {
  attrs: {
    "grid": "",
    "flow": "wrap",
    "align-items": "spread",
    "row-gap": "xx-small"
  },
  key: 9
};
const stc4 = {
  classMap: {
    "tags": true
  },
  attrs: {
    "grid": ""
  },
  key: 14
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, k: api_key, i: api_iterator} = $api;
  const {_m0} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_custom_element("ax-card", _axCard, {
    props: {
      "role": "group",
      "padding": "medium",
      "shadow": $cmp.cardFrameType
    },
    key: 1
  }, [api_element("section", stc1, [api_custom_element("ax-image", _axImage, {
    props: {
      "height": "64px",
      "width": "64px",
      "imgSrc": $cmp.listingCardData.image,
      "alt": $cmp.altTextMessage
    },
    key: 3
  }), api_element("div", stc2, [api_static_fragment($fragment1, 6, [api_static_part(0, {
    attrs: {
      "href": $cmp.listingCardData.listingUrl
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.listingCardData.title))]), api_static_fragment($fragment2, 8, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.publisher))]), api_element("div", stc3, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
    props: {
      "size": "xsmall",
      "spaceBetween": "xsmall",
      "value": $cmp.listingCardData.averageRating,
      "reviewCount": $cmp.listingCardData.reviewsAmount,
      "readOnly": true,
      "labelPosition": "right",
      "ariaLabel": $cmp.screenReaderMessageForRating
    },
    key: 10
  }), $cmp.showChat ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.chatLabel,
      "variant": "outline",
      "icon": "chat",
      "iconDescription": "Speech bubble"
    },
    key: 11
  }) : null])])]), api_static_fragment($fragment3, 13, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.description))]), api_element("section", stc4, api_iterator($cmp.tags, function (item) {
    return api_custom_element("wds-tag", _wdsTag, {
      props: {
        "href": item.filter,
        "ariaLabel": item.ariaLabel,
        "text": item.name
      },
      key: api_key(15, item.id)
    });
  }))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-54c8un93slg";
tmpl.legacyStylesheetToken = "undefined-_listingCard";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
